import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { Map } from 'immutable';
import { RuleEngineLegacyEntities } from '@bimser/components/dist/BCRuleManager';
import { convertConditions } from './convertConditions';

export function convertConditionGroups(
	conditionGroup: RuleEngineLegacyEntities.IConditionGroup,
	formData: Map<string, LayoutCreatorEntities.LayoutItem>,
	getFactKeys: (factKey: string) => void
): any {
	return {
		[conditionGroup.typeName === 'OrConditionGroup' ? 'any' : 'all']: [
			...conditionGroup.children.map(cg => convertConditionGroups(cg, formData, getFactKeys)),
			...conditionGroup.conditions.map(c => convertConditions(c, formData, getFactKeys))
		]
	};
}
